import React from 'react';

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p style={{ textAlign: 'justify' }}>
              At Natural Tooth, we believe in a gentler, smarter approach to oral health—one that honors the power of nature while embracing the best of modern dentistry. Our mission is to promote long-lasting dental wellness through treatments that are safe, sustainable, and centered on your whole-body health.
            </p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h3>Services</h3>
            <ul>
              <li>Teeth Cleaning</li>
              <li>Root Canal Treatment</li>
              <li>Dental Implants</li>
              <li>Teeth Whitening</li>
            </ul>
          </div>


          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>✉️ Email:  ramnathinlab5@gmail.com</p>
            <p> 📞 Phone: +91 9555305633
            </p>
            <p>📍 Address: D 1365, Sector D, Indira Nagar, Near Kalevam Sweets, Lucknow, Uttar Pradesh 226016
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Natural Tooth Pvt Ltd. All Rights Reserved.</p>
        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <a
        href="https://wa.me/9555305633"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
      </a>





      {/* <div className="icon-bar">
        <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
        <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
        <a href="https://www.google.com" class="google"><i class="fa fa-google"></i></a>
        <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
        <a href="#" class="youtube"><i class="fa fa-youtube-play"></i></a>
      </div> */}







    </>
  );
};

export default Footer;
